import { render, staticRenderFns } from "./Drill.vue?vue&type=template&id=6315d2b2&scoped=true&lang=pug&"
import script from "./Drill.vue?vue&type=script&lang=ts&"
export * from "./Drill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6315d2b2",
  null
  
)

export default component.exports